import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import Button from 'new-ui/Components/Button';
import { ReactComponent as StarImg } from 'assets/icons/star.svg';
import AnalyzeIcon from 'assets/icons/analyze.svg';
import UploadIcon from 'assets/icons/upload-files.svg';

export const AiAssistant = ({ uploadAction, ngsAction }) => {
  const { t } = useTranslation();
  return (
    <div className="upload-nav">
      <div className="info">
        <StarImg />
        <div className="desktop-only">{t('general.ai.assistant')}</div>
        <div className="buttons">
          <Button
            action={uploadAction}
            backgroundColor="#C77DFF"
            title={t('hcp.bar_upload_files')}
            icon={UploadIcon}
            className="upload-files desktop-only"
            width="210"
          />
          <Button
            action={uploadAction}
            backgroundColor="#C77DFF"
            title={t('hcp.bar_upload_files_mobile')}
            className="upload-files mobile-only"
            width="210"
          />
          <div className="or desktop-only">{t('general.or')}</div>
          <Button
            backgroundColor="#C77DFF"
            title={t('hcp.bar_ngs_mobile')}
            className="upload-files desktop-only"
            icon={AnalyzeIcon}
            width="210"
            action={ngsAction}
          />
          <Button
            backgroundColor="#C77DFF"
            title={t('hcp.bar_ngs_mobile')}
            className="upload-files mobile-only"
            width="210"
            action={ngsAction}
          />
        </div>
      </div>
    </div>
  );
};

AiAssistant.propTypes = {
  ngsAction: PropTypes.func.isRequired,
  uploadAction: PropTypes.func.isRequired,
};
